import { render, staticRenderFns } from "./budgetrevenuemodal.vue?vue&type=template&id=54132312"
import script from "./budgetrevenuemodal.vue?vue&type=script&lang=js"
export * from "./budgetrevenuemodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports